import request from '@/front/shared/utils/request';

export const primaryKey = 'id';

export function fetchList(id, sessionId, query = {}) {
    return request({
        url: `/sessions/${sessionId}/blocks/${id}`,
        method: 'get',
        params: query,
    });
}

export function remove(id, sessionId) {
    return request({
        url: `/sessions/${sessionId}/blocks/${id}`,
        method: 'delete',
    });
}

export function show(id, sessionId) {
    return get(id, sessionId);
}

export function get(id, sessionId) {
    return request({
        url: `/sessions/${sessionId}/blocks/${id}`,
        method: 'get',
    });
}

export function update(id, sessionId, data) {
    return request({
        url: `/sessions/${sessionId}/blocks/${id}`,
        method: 'put',
        data,
    });
}

export function store(sessionId, data) {
    return request({
        url: `/sessions/${sessionId}/blocks`,
        method: 'post',
        data,
    });
}

export function save(data) {
    if (data.hasOwnProperty(primaryKey) && data[primaryKey] != null) {
        return update(data[primaryKey], data);
    }

    return store(data);
}

export function syncCard(id, sessionId, data) {
    return request({
        url: `/sessions/${sessionId}/blocks/${id}/sync-card`,
        method: 'post',
        data,
    });
}

export function duplicate(id, sessionId, data) {
    return request({
        url: `/sessions/${sessionId}/blocks/${id}/duplicate`,
        method: 'post',
        data,
    });
}

export function copy(id, sessionId, data) {
    return request({
        url: `/sessions/${sessionId}/blocks/${id}/copy`,
        method: 'post',
        data,
    });
}

/*export function detach(id, blockId) {
    return request({
        url: `/blocks/${ blockId }/attachments/detach`,
        method: 'delete',
        params: {
            attachment_id: id,
        }
    });
}*/
